import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { BasePatchComponent } from '@app/shared/components/base/base-patch.component';
import {
    AfterContentChecked,
    Component,
    ElementRef, OnInit,
    ViewChild
} from '@angular/core';
import { CaseSummaryService, CaseSummaryUriBuilderParams } from '@app/core/services/case-summary.service';
import { CaseSummary } from '@app/shared/models/case-summary';
import { ParticipantTypes } from '@app/shared/models/participant-type';
import { TranslationEntry } from '@app/shared/models/translatable';
import { ParticipantSummary, ParticipantSummaryObject } from '@app/shared/models/participant';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { CommentsDialogComponent } from '@app/shared/dialogs/comments-dialog/comments-dialog.component';
import { ResultValuationTaxTypes } from '@app/shared/models/case-result';
import { DecisionService } from '@app/core/services/decision.service';

@Component({
    selector: 'case-summary',
    templateUrl: './case-summary.component.html',
    styleUrls: ['./case-summary.component.scss']
})
export class CaseSummaryComponent extends BasePatchComponent<CaseSummary, CaseSummaryUriBuilderParams>
                                  implements OnInit, AfterContentChecked {

    @ViewChild('commentsRow', { static: true })
    private commentsRow: ElementRef;

    protected paramsIdNames = ['id'];
    protected myConfig = { fetchAtInit: true };

    public commentsAreOverflowing: boolean;
    public decisions: string[];

    get caseId() {
        return this.id;
    }

    get summary() {
        return this.updated;
    }

    get ParticipantTypes() {
        return ParticipantTypes;
    }

    get customer() {
        return this.getInfoByType(ParticipantTypes.CUSTOMER);
    }

    get opponentVehicleOwner() {
        return this.getInfoByType(ParticipantTypes.ACCIDENT_OPPONENT_VEHICLE_OWNER);
    }

    get opponentInsurance() {
        return this.getInfoByType(ParticipantTypes.ACCIDENT_OPPONENT_INSURANCE);
    }

    get bodyShop() {
        return this.getInfoByType(ParticipantTypes.BODY_SHOP);
    }

    get taxationType(): string {
        return this.summary && this.summary.result.tax_type_id ? ` (${this.translateService.instant(ResultValuationTaxTypes.getByKey(this.summary.result.tax_type_id).trans)})` : '';
    }

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected caseSummaryService: CaseSummaryService,
                protected decisionService: DecisionService) {
        super(componentServiceBundle, caseSummaryService);
    }

    public ngOnInit() {
        super.ngOnInit();
        this.decisionService.query()
                            .subscribe((result) => {
            this.decisions = result;
        });
    }

    public ngAfterContentChecked(): void {
        this.commentsAreOverflowing = this.checkCommentsOverFlow();
    }

    protected checkCommentsOverFlow(): boolean {
        return this.commentsRow && this.commentsRow.nativeElement.scrollHeight > this.commentsRow.nativeElement.clientHeight;
    }

    protected getInfoByType(participantType: TranslationEntry): ParticipantSummary {
        return (this.summary && this.summary.participants.find(part => part.isOfType(participantType.key))) || new ParticipantSummaryObject();
    }

    protected generateUriBuilderParams(): CaseSummaryUriBuilderParams | undefined {
        if (this.myUriIdsList && this.myUriIdsList.length === this.paramsIdNames.length) {
            return new CaseSummaryUriBuilderParams(this.myUriIdsList[0]);
        }
    }

    public getBooleanTranslation(value: boolean): string {
        return value === true ? 'common.btn.yes' : (value === false ? 'common.btn.no' : '?');
    }

    public viewAllComments(): void {
        const dialogRef = this.dialog.open(CommentsDialogComponent, {
            width: '750px',
            data: {
                title: marker('detailed_processing.summary.title.comments'),
                closeBtnOverride: 'common.btn.close',
                comments: this.summary.comments
            }
        });

        dialogRef.afterClosed()
                 .subscribe();
    }
}

